import React, { useCallback, useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Row, Col, Form, Input, Switch, Divider, Radio, Table, Checkbox, Select, Modal } from 'antd';
import { BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { AddUser } from '../style';
import { createHost, gethostDetail, getPartnerCoverage, checkingListingBeforeOff, getAffiliateHostDetail, getCountryCode, hostListing } from '../../../redux/manageHost/actionCreator';
import HttpStatus from '../../../utility/status.enum';
import Notification from '../../../utility/notification';
import Heading from '../../../components/heading/heading';
import Spinner from '../../common/Spinner.js';
import { alertModal } from '../../../components/modals/antd-modals.js';
import { InfoCircleOutlined } from '@ant-design/icons';
import { fetchCmsContent } from '../../../redux/manageCms/actionCreator.js';
import { FilterFilled, DownOutlined } from '@ant-design/icons';
import { listingThemeNameList } from '../../../redux/manageTheme/actionCreator.js';
import { useCMS } from '../../../utility/useCMS.js';
import Functions from '../../../utility/functions';

const EditHostConfiguration = ({ setIsDetails }) => {
    const { backEndPrefix, hostTheme6n7, hostThemeCoastal, unsaveMessage} = global;
    const referAmount = "2.00";
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [buttonName, setButtonName] = useState('Save');
    const [spinnerLoader, setSpinnerLoader] = useState(false);
    const { hostSlug } = useParams();
    const [previewImage, setPreviewImage] = useState('');
    const [hostLogo, setHostLogo] = useState(null);
    const [status, setStatus] = useState(true);
    const [isDirty, setIsDirty] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const { Column } = Table;
    const [selectedRadio, setSelectedRadio] = useState(null);
    const [selectedSwitches, setSelectedSwitches] = useState({});
    const [partnerCoverage, setPartnerCoverage] = useState([]);
    const [selectedRadioHost, setSelectedRadioHost] = useState(null);
    const [selectedSwitchesHost, setSelectedSwitchesHost] = useState({});
    const [selectedSwitchHostChecking, setSelectedSwitchHostChecking] = useState({});
    const [originalPartnerCoverage, setOriginalPartnerCoverage] = useState([]);
    const [partnerCoverageString, setPartnerCoverageString] = useState('');
    const [allProviderCoverage, setAllProviderCoverage] = useState([]); // State to hold provider coverage data
    const [hostDetail, setHostDetail] = useState([]);
    const [initialDataLoaded, setInitialDataLoaded] = useState(false);
    const [serviceFee, setServiceFee] = useState('');
    const [phone, setPhone] = useState("");
    const [isChatEnabled, setIsChatEnabled] = useState(false);  // for Chat enable and disable

    const [selectedIsAirbnbEnable, setIsAirbnbEnable] = useState({});
    const [selectedIsAirbnbEnableHost, setIsAirbnbEnableHost] = useState({});
    const [isAirbnbListingConfig, setIsAirbnbListingConfig] = useState(false);

    const [selectedLowCostEnable, setIsLowCostEnable] = useState({});
    const [selectedLowCostEnableHost, setIsLowCostEnableHost] = useState({});
    const [isLowCostListingConfig, setIsLowCostListingConfig] = useState(false);

    const [hostRefererDropDown, setHostRefererDropDown] = useState(null); // State to hold affiliate host data
    const [selectedHostRefererSlug, setSelectedHostRefererSlug] = useState([]); // State to hold selected host referer slug
    const [selectedHostReferer, setSelectedHostReferer] = useState({
        '0': { slug: '', host_slug: '' },
        '1': { slug: '', host_slug: '' },
    });
    const [hostRefererAmount, setHostRefererAmount] = useState({
        '0': { amount: '' },
        '1': { amount: '' },
    });
    const refererHosts = [ // Referer Hosts (to manage the referer host in loop)
        { label: 'Referral Host One', name: 'referer_host_one', amountName: 'referer_amount_one' },
        { label: 'Referral Host Two', name: 'referer_host_two', amountName: 'referer_amount_two' },
    ];
    const isRendered = useRef(true);
    const [refererHostStatus, setRefererHostStatus] = useState(false);
    const alertRefererMessage = useRef('');
    const isConfirmationDoneRefererHost = useRef(false);
    const [exisitingRefererHost, setExisitingRefererHost] = useState([]);
    const [countryCodeDropdown, setCountryCodeDropdown] = useState([]);
    const [countryCodeSlug, setCountryCodeSlug] = useState(null);
    const [isRequiredCountryCode, setIsRequiredCountryCode] = useState(false);
    const [selectedIsVrboEnable, setIsVrboEnable] = useState({});
    const [selectedIsVrboEnableHost, setIsVrboEnableHost] = useState({});
    const [isVrboListingConfig, setIsVrboListingConfig] = useState(false);
    const [waiverOptionType, setWaiverOptionType] = useState(null);
    const [isRequiredWaiverOption, setIsRequiredWaiverOption] = useState(false);
    const [cmsTextHostCharge, setCMStextHostCharge] = useState('');
    const [listingThemeDropdownList, setlistingThemeDropdownList] = useState([]);
    const [selectedThemeSlug, setSelectedThemeSlug] = useState(null);
    const [previewCmsContent, setPreviewCmsContent] = useState()
    const [openthemeCms, setOpenthemeCms] = useState(false)
    const [domainName, setDomainName] = useState('')
    const { fetchCMSCommonFunction } = useCMS();

    const [memberUserDropdownList, setMemberUserDropdownList] = useState([]); // State to store member users for dropdown selection (initialized as empty array)
    const [selectedGroupAccountSlug, setSelectedGroupAccountSlug] = useState(null); // State to store the currently selected group account slug (default: null)
    const hostWaiverDropDown = [
        {
            type: 1,
            option: 'Purchase waivers for all guests',
        },
        {
            type: 2,
            option: 'Purchase waivers only if the guest selects security hold',
        },
        {
            type: 3,
            option: 'Guests choose coverage',
        },
        {
            type: 4,
            option: 'Host purchases on Airbnb/Vrbo, Guest chooses on others',
        },
        {
            type: 5,
            option: 'Purchase waivers for all guests, but guests have a required hold',
        },
    ];

    const WAIVEROPTION = {
        PURCHASE_WAIVERS_FOR_ALL_GUESTS: 1,
        PURCHASE_WAIVERS_IF_SECURITY_HOLD: 2,
        GUESTS_CHOOSE_COVERAGE: 3,
        HOST_PURCHASES_ON_AIRBNB_VRBO_GUEST_CHOICES_ON_OTHERS: 4,
        PURCHASE_WAIVERS_FOR_ALL_GUESTS_WITH_HOLD_ONLY: 5,
    };

    const hostReferrerMessageOne = 'Are you sure you want to remove the referral host?';
    const hostReferrerMessageTwo = 'Are you sure you want to replace the current referral host?';
    const alertWaiverOptionMessage = "To turn on Airbnb or Vrbo flow, please select Airbnb/Vrbo flow in dropdown";
    const alertWaiverOptionMessageAllGuest = "You are attempting to switch from a Host-Buys model to a Guest-Choose model, but you have a coverage selected that cannot be used for Guest Choose. You must remove that coverage option before being able to switch models.";

    useEffect(() => {
        global.isDirtyGlobal = isDirty;
    }, [isDirty])

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (hostSlug) {
                    setSpinnerLoader(true);
                    setButtonName(`Save`);

                    const hostResponse = await dispatch(gethostDetail(hostSlug));
                    if (hostResponse?.status !== HttpStatus.HTTP_OK) {
                        navigate(`${backEndPrefix}/host`);
                        return;
                    }
                    const responseData = hostResponse?.result;
                    setHostDetail(responseData);
                    form.setFieldsValue({
                        name: responseData?.name,
                        email: responseData?.email,
                        display_name: responseData?.display_name,
                        company_name: responseData?.company_name || '',
                        stripe_customer_id: responseData?.stripe_customer_id || '',
                        theme_slug: responseData?.theme_info?.slug,
                        domain_name: responseData?.domain,
                        group_account_slug: responseData?.group_account_info?.map(item => item.slug), // Assign group account slug from response data
                    });
                    setPhone(responseData?.phone_number);
                    setPreviewImage(responseData?.image);
                    setStatus(responseData?.status_id === 1);
                    setOriginalPartnerCoverage(responseData?.partner_coverage || []);
                    setServiceFee(responseData?.platform_service_fee);
                    setSelectedThemeSlug(responseData?.theme_info?.slug);
                    setDomainName(responseData?.domain ?? '')
                    setSelectedThemeSlug(responseData?.theme_info?.slug);
                    setSelectedGroupAccountSlug(responseData.group_account_info?.map(item => item.slug)); // Update state with the selected group account slug from response data
                    if (responseData?.low_cost_listing_count) { // found true means configured to listing
                        setIsLowCostListingConfig(true)
                    }
                    if (responseData?.airbnb_listing_count) { // found true means configured to listing
                        setIsAirbnbListingConfig(true)
                    }
                    if (responseData?.vrbo_listing_count) { // found true means configured to listing
                        setIsVrboListingConfig(true)
                    }
                    setCountryCodeSlug(responseData?.country_slug || null);
                    setIsChatEnabled(responseData?.is_chat_enable === 1 ? true : false);    // fetching Chat enable and disable status
                    setWaiverOptionType(responseData?.payment_type || null);
                    const affiliateData = responseData?.affiliate_host || [];
                    if (affiliateData.length > 0) { // If from DB get the affiliate data
                        const newHostReferer = { ...selectedHostReferer };
                        const newAmountValue = { ...hostRefererAmount };
                        affiliateData.forEach((item, index) => {
                            newHostReferer[index] = {
                                slug: item.slug,
                                host_slug: item.host_slug
                            };
                            newAmountValue[index] = {
                                amount: item.amount
                            };
                        });

                        // Set state for hostReferer and amountValue
                        form.setFieldsValue({
                            referer_host_one: newHostReferer[0]?.host_slug || null,
                            referer_host_two: newHostReferer[1]?.host_slug || null,
                            referer_amount_one: newAmountValue[0]?.amount || null,
                            referer_amount_two: newAmountValue[1]?.amount || null,
                        });
                        setSelectedHostReferer(newHostReferer);
                        setHostRefererAmount(newAmountValue);
                        setExisitingRefererHost(affiliateData);
                        setRefererHostStatus(true);
                    }
                    global.isShowCardsOnFile = responseData?.is_allowed_card_file ?? global.isShowCardsOnFile;
                } else {
                    setButtonName(`Save`);
                    setServiceFee('10')
                }
                setSpinnerLoader(false);
            } catch (error) { }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const fetchCountryCode = async () => {
            try {
                const hostResponse = await dispatch(getCountryCode());
                if (hostResponse?.status === HttpStatus.HTTP_OK) {
                    const countryCodeData = hostResponse?.result;
                    setCountryCodeDropdown(countryCodeData);
                }
            } catch (error) { }
        };
        fetchCountryCode();
        fetchThemeListing();
        fetchMemberUserData();
    }, []);

    useEffect(() => { // Fetching the affiliate data
        const getAffiliateData = async () => {
            setSpinnerLoader(true);
            try {
                const formData = { host_slug: hostSlug };
                const hostResponse = await dispatch(getAffiliateHostDetail(formData));
                if (hostResponse?.status === HttpStatus.HTTP_OK) {
                    const responseData = hostResponse?.result;
                    setHostRefererDropDown(responseData?.length > 0 ? responseData : []);
                }
            } catch (error) {
                console.error("Error fetching affiliate data:", error);
            } finally {
                setSpinnerLoader(false);
            }
        };
        getAffiliateData();
    }, [hostSlug]);

    useEffect(() => { // on edit case the selected host referer slug from DB stored in state to hide from the dropdown
        if (isRendered.current && selectedHostReferer[0]?.host_slug && hostRefererDropDown) {
            const newSelectedHostRefererSlug = [...selectedHostRefererSlug];
            if (selectedHostReferer[0]?.host_slug) {
                newSelectedHostRefererSlug.push(selectedHostReferer[0]?.host_slug);
            }
            if (selectedHostReferer[1]?.host_slug) {
                newSelectedHostRefererSlug.push(selectedHostReferer[1]?.host_slug);
            }
            setSelectedHostRefererSlug(newSelectedHostRefererSlug); // Used to hide the referer host from dropdown
            isRendered.current = false; // Helps to execute this code only first (initial) render
        }
    }, [selectedHostReferer, hostRefererDropDown]);

    useEffect(() => {
        const fetchCmsContentData = async () => {
            try {
                const fetchCmsContentResponse = await dispatch(
                    fetchCmsContent({
                        action_type: 13,
                    }),
                );
                if (fetchCmsContentResponse.status === HttpStatus.HTTP_OK) {
                    setCMStextHostCharge(fetchCmsContentResponse.result.description);
                } else {
                    // show Error
                }
            } catch (error) { }
        };
        fetchCmsContentData();
    }, [])

    const fetchThemeListing = async () => {
        try {
            const listingThemeResponse = await dispatch(
                listingThemeNameList(),
            );
            if (listingThemeResponse.status === HttpStatus.HTTP_OK) {
                setlistingThemeDropdownList(listingThemeResponse.result);
            }
        } catch (error) { }
    };

    const fetchMemberUserData = async () => {
        try {
            const membersResponse = await dispatch(
                hostListing({
                    is_filter: 1,
                    owner_user_slug: hostSlug
                }));
            if (membersResponse.status === HttpStatus.HTTP_OK) { // Check if API response is successful
                setMemberUserDropdownList(membersResponse.result); // Update state with the list of member users for dropdown
            }
        } catch (error) { }
    };

    const askingConfirmation = async (filterAffiliateHostDetail) => {
        let isAlertMessage = false;
        if (exisitingRefererHost.length > 0 && hostSlug) { // data comes from DB about referer host on edit case
            if (filterAffiliateHostDetail.length === 0) {
                alertRefererMessage.current = hostReferrerMessageOne;
                isAlertMessage = true;
            } else {
                let isNewAdded = 0;
                let exisitingLength = exisitingRefererHost.length;
                filterAffiliateHostDetail.map(item => {
                    const findExisitingRefererHost = exisitingRefererHost.find((refererHost) => refererHost.host_slug === item.host_slug);
                    if (!findExisitingRefererHost) { // New referer host added
                        ++isNewAdded;
                    } else { // The exisiting referer host found
                        --exisitingLength;
                    }
                })
                if (exisitingLength !== 0) { // all changes are not found same
                    if (isNewAdded === 0) { // exisiting one is removed No new referer host selected
                        alertRefererMessage.current = hostReferrerMessageOne;
                        isAlertMessage = true;
                    } else { // the new one is added with removal the exisiting the referer host
                        alertRefererMessage.current = hostReferrerMessageTwo;
                        isAlertMessage = true;
                    }
                }
            }
        }
        return isAlertMessage;
    }

    const alertRefererPopUp = () => {
        alertModal.confirm({
            title: `${alertRefererMessage.current}`,
            className: 'confirm_modal delete_listing_modal',
            onOk() {
                form
                    .validateFields()
                    .then(() => {
                        form.submit();
                    })
                    .catch((errorInfo) => { });
                isConfirmationDoneRefererHost.current = true;
            },
            onCancel() {
                isConfirmationDoneRefererHost.current = false;
            },
        });
    };

    const handleSubmit = useCallback(
        // edit host section
        async (values) => {
            // Service Fee Blank Validation Added by Gautam
            // if(serviceFee === ""){
            //   setBlankServiceFee(true)
            //   return false;
            // }
            // Convert to the desired format
            if ([1, 2, 3, 5].includes(waiverOptionType)) { // If Option 1,2,3 or 5 one of selected then airbnb or vrbo switches should be off
                // checking switches for Airbnb and Vrbo
                const isAirbnbVrboEnable = partnerCoverage?.some(
                    (coverage) => coverage.is_airbnb_enable === 1 || coverage.is_vrbo_enable === 1,
                );
                if (isAirbnbVrboEnable) { // If Airbnb or Vrbo is enabled then show alert as we only allow it for option 4
                    Notification.addNotificationError(alertWaiverOptionMessage);
                    return;
                }
            }
            const waiverOptionsToCheck = [
                WAIVEROPTION.PURCHASE_WAIVERS_IF_SECURITY_HOLD,
                WAIVEROPTION.GUESTS_CHOOSE_COVERAGE,
                WAIVEROPTION.HOST_PURCHASES_ON_AIRBNB_VRBO_GUEST_CHOICES_ON_OTHERS,
            ];
            if (waiverOptionsToCheck.includes(waiverOptionType)) {
                const isCheckOutProviderOptionEnable = partnerCoverage?.some(
                    (coverage) => coverage.is_checkout_invoicing_enabled === 1,
                );
                if (isCheckOutProviderOptionEnable) {
                    Notification.addNotificationError(alertWaiverOptionMessageAllGuest);
                    return;
                }
            }

            let filterAffiliateHostDetail = [];
            if (refererHostStatus) {
                filterAffiliateHostDetail = Object.keys(selectedHostReferer)
                    .filter((key) => selectedHostReferer[key].host_slug && hostRefererAmount[key].amount)
                    .map((key) => ({
                        slug: selectedHostReferer[key].slug || "",
                        host_slug: selectedHostReferer[key].host_slug,
                        amount: hostRefererAmount[key].amount,
                    }));
            }

            if (!isConfirmationDoneRefererHost.current) { // After confirmation (Press Ok) then skip this process
                const isEverything = await askingConfirmation(filterAffiliateHostDetail);
                if (isEverything) {
                    alertRefererPopUp();
                    return;
                }
            }

            const hasSwitchSelected =
                Object.values(selectedSwitches).includes(true) || Object.values(selectedSwitchesHost).includes(true);
            // Check if a default coverage option is selected only when a switch is selected
            if (!hostSlug && !selectedRadio) {
                Notification.addNotificationError('Please select a default coverage option.');
                return false;
            }
            if (hasSwitchSelected && !selectedRadioHost && !selectedRadio) {
                Notification.addNotificationError('Please select a default coverage option.');
                return false;
            }
            if (!waiverOptionType) {
                return false;
            }
            let status_id = status === true ? 1 : 2;
            let requestData = { ...values, status_id, platform_service_fee: serviceFee, phone_number: phone, is_chat_enable: isChatEnabled ? 1 : 2, affiliate_host: JSON.stringify(filterAffiliateHostDetail) };
            if (hostSlug) {
                const slug = hostSlug;
                requestData = { ...requestData, slug };
            }
            if (hostLogo) {
                const image = hostLogo;
                requestData = { ...requestData, image };
            }

            setSpinnerLoader(true);
            let is_user_setting_action = 1;

            const createOrUpdateHost = async () => {
                try {
                    requestData = { ...requestData, is_user_setting_action, partner_coverage: partnerCoverageString, country_slug: countryCodeSlug, payment_type: waiverOptionType, theme_slug: selectedThemeSlug ? selectedThemeSlug : null, group_account_slug: selectedGroupAccountSlug ? selectedGroupAccountSlug : null };

                    const hostCreateOrUpdateResponse = await dispatch(
                        createHost(requestData, (response) => {
                            return response;
                        }),
                    );
                    if (hostCreateOrUpdateResponse?.status !== HttpStatus.HTTP_OK) {
                        if (hostCreateOrUpdateResponse?.result?.errorDetail?.length > 0) {
                            Notification.addNotificationError(hostCreateOrUpdateResponse?.result?.errorDetail[0]?.errorMessage[0]);
                        } else {
                            Notification.addNotificationError(hostCreateOrUpdateResponse?.message);
                        }
                    } else {
                        Notification.addNotificationSuccess(hostCreateOrUpdateResponse?.message);
                        const resultSlug = hostCreateOrUpdateResponse?.result?.slug;
                        global.isDirtyGlobal = false;
                        setIsDetails(true)
                    }
                    setSpinnerLoader(false);
                } catch (error) {
                    console.log(error, 'error');

                }
            };
            createOrUpdateHost();
        },
        [navigate, dispatch, hostLogo, hostSlug, status, previewImage, partnerCoverageString, serviceFee, phone, isChatEnabled, hostRefererAmount, selectedHostReferer, refererHostStatus, countryCodeSlug, waiverOptionType, partnerCoverage, selectedThemeSlug, selectedGroupAccountSlug],
    );

    useEffect(() => {
        // fetching partner coverage API
        const fetchProviderCoverage = async () => {
            try {
                const allProviderCoverageResponse = await dispatch(getPartnerCoverage());
                if (allProviderCoverageResponse?.status === HttpStatus.HTTP_OK) {
                    const allProviderCoverageData = allProviderCoverageResponse.result;
                    setAllProviderCoverage(allProviderCoverageData); // Store provider coverage data in state
                }
                setInitialDataLoaded(true);
            } catch (error) {
                setSpinnerLoader(false);
            }
        };
        fetchProviderCoverage();
    }, []);

    useEffect(() => {
        if (initialDataLoaded) {
            if (originalPartnerCoverage.length > 0 || allProviderCoverage.length > 0) {
                const initialRadioHost =
                    originalPartnerCoverage.find((item) => item.is_default === 1)?.partner_coverage_slug || null;

                const initialSwitchesHost = originalPartnerCoverage.reduce((acc, item) => {
                    if (item.is_coverage_enable === 1) {
                        acc[item.partner_coverage_slug] = true;
                    }
                    return acc;
                }, {});

                const initialSwitchesHostSlug = originalPartnerCoverage.reduce((acc, item) => {
                    if (item.is_coverage_enable === 1) {
                        acc[item.partner_coverage_slug] = item.slug;
                    }
                    return acc;
                }, {});

                // setting initial low cost waiver
                const initialIsAirbnbEnable =
                    originalPartnerCoverage.find((item) => item?.is_airbnb_enable === 1)?.partner_coverage_slug || 0;
                const initialIsLowCostEnable =
                    originalPartnerCoverage.find((item) => item?.is_low_cost_enable === 1)?.partner_coverage_slug || 0;
                const initialIsVrboEnable =
                    originalPartnerCoverage.find((item) => item?.is_vrbo_enable === 1)?.partner_coverage_slug || 0;

                setSelectedRadioHost(initialRadioHost);
                setSelectedSwitchesHost(initialSwitchesHost);
                setSelectedSwitchHostChecking(initialSwitchesHostSlug)

                setIsAirbnbEnableHost(initialIsAirbnbEnable); // setting initial low cost waiver
                setIsLowCostEnableHost(initialIsLowCostEnable); // setting initial low cost waiver
                setIsVrboEnableHost(initialIsVrboEnable); // setting initial vrbo waiver

                setPartnerCoverage(
                    originalPartnerCoverage.map((item) => ({
                        is_airbnb_enable: item.is_airbnb_enable || 0,
                        is_low_cost_enable: item.is_low_cost_enable || 0,
                        is_vrbo_enable: item.is_vrbo_enable || 0,
                        is_default: item.is_default,
                        is_coverage_enable: item?.is_coverage_enable || 0,
                        partner_coverage_slug: item.partner_coverage_slug,
                        slug: item.slug || '',
                        configuration_listing_count: item.configuration_listing_count || 0,
                        is_checkout_invoicing_enabled: item.is_checkout_invoicing_enabled || 2,
                    })),
                );
                const combinedData = formatAndCombineData(allProviderCoverage, originalPartnerCoverage);
                setDataSource(combinedData);
            }
        }
    }, [initialDataLoaded, allProviderCoverage, originalPartnerCoverage]);

    const handleCancel = () => {
        if (isDirty) {
            const confirmCancel = window.confirm(unsaveMessage);
            if (confirmCancel) {
                setIsDirty(false);
                global.isDirtyGlobal = false;
                setIsDetails(true);
            }
        } else {
            setIsDetails(true);
        }
    }

    const turningOff = async (formData) => {
        try {
            const statusResponse = await dispatch(checkingListingBeforeOff(formData));
            return statusResponse?.status !== HttpStatus.HTTP_OK;
        } catch (error) {
            console.error("Error in turningOff function:", error);
            return true; // Return true to indicate that turning off failed
        }
    };

    const changeStatus = async (status) => {
        try {
            setStatus(status);
        } catch (error) {
            console.error("Error in changeStatus function:", error);
        }
    };

    const checkValidation = () => {

        if (!waiverOptionType) {
            setIsRequiredWaiverOption(true);
        }
        form
            .validateFields()
            .then(() => {
                form.submit();
            })
            .catch((errorInfo) => { });
        setTimeout(() => {
            const errorElements = document.querySelectorAll('.ant-form-item-has-error');
            if (errorElements.length > 0) {
                const firstErrorElement = errorElements[0] ?? 0;
                firstErrorElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'start',
                });
            }
        }, 300);
    };

    const handleInputChange = () => {
        setIsDirty(true);
    };

    // radio button handling
    const handleRadioChangeGeneral = (e, isHost = false) => {
        if (typeof e === 'string') {
            const isStaticPartnerExist = allProviderCoverage?.some(partner => partner.slug === e);
            // If static slug (default partner) not found then return;
            if (!isStaticPartnerExist) {
                return;
            }
        }
        const newPartnerCoverageSlug = e?.target?.value ?? e;
        const previousRadio = isHost ? selectedRadioHost : selectedRadio;

        let updatedArray = partnerCoverage.map((item) => {
            if (item.partner_coverage_slug === newPartnerCoverageSlug) {
                // comparing slug value from API and recieving data for host
                return {
                    ...item,
                    is_default: 1,
                    is_coverage_enable: 1,
                    slug: item.slug || '',
                };
            } else if (item.partner_coverage_slug === previousRadio) {
                return {
                    ...item,
                    is_default: 0,
                    slug: item.slug || '',
                };
            }
            setIsDirty(true)
            return item;
        });
        if (!updatedArray.find((item) => item.partner_coverage_slug === newPartnerCoverageSlug)) {
            const newItem =
                originalPartnerCoverage.find((item) => item.partner_coverage_slug === newPartnerCoverageSlug) || {};
            updatedArray.push({
                ...newItem,
                is_default: 1,
                is_coverage_enable: 1,
                partner_coverage_slug: newPartnerCoverageSlug,
                slug: newItem.slug || '',
            });
        }
        if (!updatedArray.find((item) => item.partner_coverage_slug === previousRadio)) {
            const previousItem = originalPartnerCoverage.find((item) => item.partner_coverage_slug === previousRadio);
            if (previousItem) {
                updatedArray.push({
                    ...previousItem,
                    is_default: 0,
                });
            }
        }
        const updatedSwitches = isHost
            ? {
                ...selectedSwitchesHost,
                [newPartnerCoverageSlug]: true,
                [previousRadio]: selectedSwitchesHost[previousRadio] || false,
            }
            : {
                ...selectedSwitches,
                [newPartnerCoverageSlug]: true,
                [previousRadio]: selectedSwitches[previousRadio] || false,
            };
        const cleanedArray = updatedArray.map((item) => ({
            ...item,
            is_airbnb_enable: item?.is_airbnb_enable || 0,
            is_low_cost_enable: item?.is_low_cost_enable || 0,
            is_vrbo_enable: item?.is_vrbo_enable || 0,
            is_default: item.is_default,
            is_coverage_enable: item?.is_coverage_enable || 0,
            partner_coverage_slug: item.partner_coverage_slug,
            slug: item.slug || '',
        }));

        setPartnerCoverageString(JSON.stringify(cleanedArray));

        isHost ? setSelectedRadioHost(newPartnerCoverageSlug) : setSelectedRadio(newPartnerCoverageSlug);

        isHost ? setSelectedSwitchesHost(updatedSwitches) : setSelectedSwitches(updatedSwitches);

        setPartnerCoverage(updatedArray);
    };

    // switch handling
    const handleSwitchChangeGeneral = async (checked, partnerCoverageSlug, isHost = false) => {
        const selectedCoverage = partnerCoverage.find((item) => item.partner_coverage_slug === partnerCoverageSlug);

        if (!checked && hostSlug && selectedSwitchHostChecking[partnerCoverageSlug] && selectedCoverage) {
            const formData = { "slug": selectedSwitchHostChecking[partnerCoverageSlug] };
            const cannotTurnOff = await turningOff(formData);
            if (cannotTurnOff) { // cannot turned off current provider found linked with any listing
                Notification.addNotificationError(`Coverage is currently configured to a listing and can’t be turned off.`);
                return;
            }
        }

        const updatedSwitches = isHost
            ? { ...selectedSwitchesHost, [partnerCoverageSlug]: checked }
            : { ...selectedSwitches, [partnerCoverageSlug]: checked };

        isHost ? setSelectedSwitchesHost(updatedSwitches) : setSelectedSwitches(updatedSwitches);

        let updatedArray = [...partnerCoverage];
        if (!checked) {
            updatedArray = updatedArray
                .map((item) => {
                    // Check if partner_coverage_slug matches the target value
                    if (item.partner_coverage_slug === partnerCoverageSlug) {
                        // If `is_airbnb_enable` is 1, update the item
                        if (item.is_airbnb_enable == 1 || item.is_low_cost_enable == 1) {
                            // Set `is_coverage_enable` to 0 and return updated item
                            setIsDirty(true); // Mark as dirty only when item is updated
                            return {
                                ...item, // Spread the existing properties
                                is_coverage_enable: checked ? 1 : 0, // Update the `is_coverage_enable`
                            };
                        } else {
                            // Remove the item entirely by returning null
                            return null;
                        }
                    }
                    // Return the item unchanged if `partner_coverage_slug` doesn't match
                    return item;
                })
                .filter((item) => item !== null); // Filter out null items (the ones that need to be removed)        
        } else {
            const originalItem = originalPartnerCoverage.find((item) => item.partner_coverage_slug === partnerCoverageSlug);
            const existingItem = updatedArray.find((item) => item.partner_coverage_slug === partnerCoverageSlug);

            if (existingItem) {
                existingItem.is_default = (isHost ? selectedRadioHost : selectedRadio) === partnerCoverageSlug ? 1 : 0;
                existingItem.configuration_listing_count = originalItem?.configuration_listing_count || 0;
                existingItem.slug = originalItem?.slug || existingItem.slug || '';
                existingItem.is_coverage_enable = 1;
            } else {
                updatedArray.push({
                    is_default: (isHost ? selectedRadioHost : selectedRadio) === partnerCoverageSlug ? 1 : 0,
                    partner_coverage_slug: partnerCoverageSlug,
                    slug: originalItem?.slug || '',
                    configuration_listing_count: originalItem?.configuration_listing_count || 0,
                    is_coverage_enable: 1,
                    is_airbnb_enable: (isHost ? selectedIsAirbnbEnableHost : selectedIsAirbnbEnable) === partnerCoverageSlug ? 1 : 0,
                    is_low_cost_enable: (isHost ? selectedLowCostEnableHost : selectedLowCostEnable) === partnerCoverageSlug ? 1 : 0,
                    is_vrbo_enable: (isHost ? selectedIsVrboEnableHost : selectedIsVrboEnable) === partnerCoverageSlug ? 1 : 0,
                });
            }
        }
        const cleanedArray = updatedArray.map((item) => ({
            ...item,
            is_airbnb_enable: item?.is_airbnb_enable || 0,
            is_low_cost_enable: item?.is_low_cost_enable || 0,
            is_vrbo_enable: item?.is_vrbo_enable || 0,
            is_default: item.is_default,
            partner_coverage_slug: item.partner_coverage_slug,
            slug: item.slug || '',
            is_coverage_enable: item?.is_coverage_enable
        }));
        setPartnerCoverageString(JSON.stringify(cleanedArray));
        setPartnerCoverage(updatedArray);
        setIsDirty(true)
    };

    const formatAndCombineData = (allProviderCoverage, partnerCoverageData) => {
        const formatValue = (value, rateType) => {
            return value > 0
                ? rateType === 1
                    ? `$${Number(value).toLocaleString('en-US')}`
                    : `${Number(value).toLocaleString('en-US')}%`
                : '';
        };
        // getting list of provider data for host, also all coverage provider
        return allProviderCoverage.map((provider) => {
            const hostData = partnerCoverageData.find((item) => item.partner_coverage_slug === provider.slug) || {};
            return {
                ...provider,
                fee: formatValue(provider.fee, provider.rate_type), // both
                additional_night_fee: formatValue(provider.additional_night_fee, provider.rate_type), // both
                coverage_limit:
                    provider.coverage_limit > 0 ? '$' + Number(provider.coverage_limit).toLocaleString('en-US') : '',
                min_additional_night_rate:
                    provider.min_additional_night_rate > 0
                        ? '$' + Number(provider.min_additional_night_rate).toLocaleString('en-US')
                        : '',
                mrp: provider.mrp > 0 ? '$' + Number(provider.mrp).toLocaleString('en-US') : '',
                min_security_hold:
                    provider.min_security_hold > 0 ? '$' + Number(provider.min_security_hold).toLocaleString('en-US') : '',
                on_night_over: provider.on_night_over > 0 ? Number(provider.on_night_over).toLocaleString('en-US') : '',
                is_airbnb_enable: hostData.is_airbnb_enable || 0,
                is_low_cost_enable: hostData.is_low_cost_enable || 0,
                is_default: hostData.is_default || 0,
                is_coverage_enable: hostData.is_coverage_enable || 0,
                is_vrbo_enable: hostData.is_vrbo_enable || 0,
                slug: provider.slug,
                partner_coverage_slug: hostData.partner_coverage_slug || provider.partner_coverage_slug,
                partner_id: hostData.partner_id || provider.partner_id,
                configuration_listing_count: hostData.configuration_listing_count || 0,
            };
        });
    };

    const handleServiceFeeChange = (e) => {
        const value = e.target.value;
        let cleanedValue = value.replace(/[^0-9]/g, '');
        if (cleanedValue >= 0 && cleanedValue < 100) {
            setServiceFee(cleanedValue);
        }
        setIsDirty(true)
    };

    // Chat Enable or Disable
    const handleChatEnabledChange = (event) => {
        const isChecked = event.target.checked;
        setIsChatEnabled(isChecked);
    };

    // Function to handle the airbnb waiver selection
    const handleAirbnbEnableWaiver = (isOnStatus, partnerCoverageSlug, isHost = false) => {
        const isChecked = isOnStatus;
        if (isChecked && waiverOptionType !== 4) { // If Airbnb or Vrbo flow is not selected then don't allow to turn on Airbnb
            Notification.addNotificationError(alertWaiverOptionMessage);
            return;
        }
        const newPartnerCoverageSlug = isChecked ? partnerCoverageSlug : '';
        const previousWaiver = isHost ? selectedIsAirbnbEnableHost : selectedIsAirbnbEnable;
        if (!isChecked && isAirbnbListingConfig) {
            Notification.addNotificationError('Airbnb currently configured to a listing and can’t be turned off.');
            return;
        }
        // Update the partner coverage array based on the new selection
        let updatedArray = partnerCoverage.map((item) => {
            if (item.partner_coverage_slug === newPartnerCoverageSlug) {
                // Comparing slug value from API and receiving data for host
                return {
                    ...item,
                    is_airbnb_enable: isChecked ? 1 : 0,
                    slug: item.slug || '',
                };
            } else if (item.partner_coverage_slug === previousWaiver) {
                if (item.is_default === 0 && item.is_coverage_enable === 0 && item.is_low_cost_enable === 0) {
                    return null;
                }
                return {
                    ...item,
                    is_airbnb_enable: 0,
                    slug: item.slug || '',
                };
            }
            setIsDirty(true)
            return item;
        }).filter(item => item !== null);

        // Add new item to the array if it doesn't exist
        if (!updatedArray.find((item) => item.partner_coverage_slug === newPartnerCoverageSlug) && isChecked) {
            const newItem = originalPartnerCoverage.find((item) => item.partner_coverage_slug === newPartnerCoverageSlug) || {};
            updatedArray.push({
                ...newItem,
                is_airbnb_enable: isChecked ? 1 : 0,
                is_low_cost_enable: (isHost ? selectedLowCostEnableHost : selectedLowCostEnable) === partnerCoverageSlug ? 1 : 0,
                is_vrbo_enable: (isHost ? selectedIsVrboEnableHost : selectedIsVrboEnable) === partnerCoverageSlug ? 1 : 0,
                is_default: (isHost ? selectedRadioHost : selectedRadio) === partnerCoverageSlug ? 1 : 0,
                partner_coverage_slug: newPartnerCoverageSlug,
                slug: newItem.slug || '',
                is_coverage_enable: 0,
            });
        }

        const cleanedArray = updatedArray.map((item) => ({
            ...item,
            is_coverage_enable: item?.is_coverage_enable || 0,
            is_airbnb_enable: item?.is_airbnb_enable || 0,
            is_low_cost_enable: item?.is_low_cost_enable || 0,
            is_vrbo_enable: item?.is_vrbo_enable || 0,
            is_default: item.is_default,
            partner_coverage_slug: item?.partner_coverage_slug,
            slug: item?.slug || '',
        }));
        //  Update the state with the new values
        setPartnerCoverageString(JSON.stringify(cleanedArray));
        isHost ? setIsAirbnbEnableHost(newPartnerCoverageSlug) : setIsAirbnbEnable(newPartnerCoverageSlug);
        setPartnerCoverage(updatedArray);
    };

    // Function to handle the low cost waiver selection
    const handleLowCostEnableWaiver = (isOnStatus, partnerCoverageSlug, isHost = false) => {
        const isChecked = isOnStatus;
        const newPartnerCoverageSlug = isChecked ? partnerCoverageSlug : '';
        const previousWaiver = isHost ? selectedLowCostEnableHost : selectedLowCostEnable;
        if (!isChecked && isLowCostListingConfig) {
            Notification.addNotificationError('Low cost currently configured to a listing and can’t be turned off.');
            return;
        }
        // Update the partner coverage array based on the new selection
        let updatedArray = partnerCoverage.map((item) => {
            if (item.partner_coverage_slug === newPartnerCoverageSlug) {
                // Comparing slug value from API and receiving data for host
                return {
                    ...item,
                    is_low_cost_enable: isChecked ? 1 : 0,
                    slug: item.slug || '',
                };
            } else if (item.partner_coverage_slug === previousWaiver) {
                if (item.is_default === 0 && item.is_coverage_enable === 0 && item.is_airbnb_enable === 0) {
                    return null;
                }
                return {
                    ...item,
                    is_low_cost_enable: 0,
                    slug: item.slug || '',
                };
            }
            setIsDirty(true)
            return item;
        }).filter(item => item !== null);

        // Add new item to the array if it doesn't exist
        if (!updatedArray.find((item) => item.partner_coverage_slug === newPartnerCoverageSlug) && isChecked) {
            const newItem = originalPartnerCoverage.find((item) => item.partner_coverage_slug === newPartnerCoverageSlug) || {};
            updatedArray.push({
                ...newItem,
                is_low_cost_enable: isChecked ? 1 : 0,
                is_airbnb_enable: (isHost ? selectedIsAirbnbEnableHost : selectedIsAirbnbEnable) === partnerCoverageSlug ? 1 : 0,
                is_vrbo_enable: (isHost ? selectedIsVrboEnableHost : selectedIsVrboEnable) === partnerCoverageSlug ? 1 : 0,
                is_default: (isHost ? selectedRadioHost : selectedRadio) === partnerCoverageSlug ? 1 : 0,
                partner_coverage_slug: newPartnerCoverageSlug,
                slug: newItem.slug || '',
                is_coverage_enable: 0,
            });
        }

        const cleanedArray = updatedArray.map((item) => ({
            ...item,
            is_coverage_enable: item?.is_coverage_enable || 0,
            is_low_cost_enable: item?.is_low_cost_enable || 0,
            is_airbnb_enable: item?.is_airbnb_enable || 0,
            is_vrbo_enable: item?.is_vrbo_enable || 0,
            is_default: item.is_default,
            partner_coverage_slug: item?.partner_coverage_slug,
            slug: item?.slug || '',
        }));
        //  Update the state with the new values
        setPartnerCoverageString(JSON.stringify(cleanedArray));
        isHost ? setIsLowCostEnableHost(newPartnerCoverageSlug) : setIsLowCostEnable(newPartnerCoverageSlug);
        setPartnerCoverage(updatedArray);
    };

    // Worked code
    const handleSelectRefererHost = (selectedHostSlug, index) => { // handle change for referer host dropdown 
        // finding the referer host from the dropdown based on selected slug
        const foundHost = hostRefererDropDown.find((item) => item.slug === selectedHostSlug);
        if (index === 0) { // referer host one
            form.setFieldsValue({
                referer_host_one: foundHost?.name || null,
            });
        } else { // referer host two
            form.setFieldsValue({
                referer_host_two: foundHost?.name || null,
            });
        }
        // selectHostReferer is used to keep track the selected referer host
        const updatedRefererHosts = { ...selectedHostReferer };

        if (foundHost) {// If referer host found from dropdown

            // If host_slug not empty that means we are updating the dropdown value
            if (updatedRefererHosts[index]?.host_slug) {
                const updatedSelectedHostRefererSlug = selectedHostRefererSlug.map((slug) =>
                    slug === updatedRefererHosts[index].host_slug ? selectedHostSlug : slug
                );
                setSelectedHostRefererSlug(updatedSelectedHostRefererSlug);
            } else {
                // here dropdown value was empty so we push the slug to hide referer host from another dropdown
                const updatedSelectedHostRefererSlug = [...selectedHostRefererSlug, selectedHostSlug];
                setSelectedHostRefererSlug(updatedSelectedHostRefererSlug);
                // By default $2 is added to the amount
                const updatedRefererHosts = { ...hostRefererAmount };
                updatedRefererHosts[index] = { // set the value of amount
                    amount: referAmount,
                };
                if (index === 0) {
                    form.setFieldsValue({
                        referer_amount_one: referAmount,
                    });
                } else {
                    form.setFieldsValue({
                        referer_amount_two: referAmount,
                    });
                }
                setHostRefererAmount(updatedRefererHosts);
            }

            // Updating the referer host one or two based on index
            updatedRefererHosts[index] = {
                slug: updatedRefererHosts[index]?.slug || "",
                host_slug: foundHost.slug
            };

            setSelectedHostReferer(updatedRefererHosts); // update the state
        } else { // If dropdown is erased by user
            // remove the referer host from the selected referer host
            const refererHostSlug = selectedHostRefererSlug.filter((slug) => slug !== updatedRefererHosts[index]?.host_slug)

            // reset that host referer based on the index
            updatedRefererHosts[index] = {
                slug: "",
                host_slug: ""
            };

            // update the state's
            setSelectedHostReferer(updatedRefererHosts);
            setSelectedHostRefererSlug(refererHostSlug);
        }
    };

    const handleChangeAmount = (event, index) => {
        let amountValue = event.target.value;

        // Allow only numbers and one decimal point
        amountValue = amountValue.replace(/[^0-9.]/g, '');

        // Prevent more than one decimal point
        const parts = amountValue.split('.');
        if (parts.length > 2) {
            amountValue = parts[0] + '.' + parts[1];
        }

        // Limit to two decimal places
        if (parts[1]?.length > 2) {
            amountValue = parts[0] + '.' + parts[1].substring(0, 2);
        }

        // Handle leading zeros
        if (amountValue.startsWith('0') && !amountValue.startsWith('0.')) {
            amountValue = amountValue.replace(/^0+/, ''); // Remove leading zeros
            if (amountValue === '') {
                amountValue = '0'; // If all zeros are removed, set to '0'
            }
        }

        if (index === 0) {
            form.setFieldsValue({
                referer_amount_one: amountValue,
            });
        } else {
            form.setFieldsValue({
                referer_amount_two: amountValue,
            });
        }
        const updatedRefererHosts = { ...hostRefererAmount };
        updatedRefererHosts[index] = { // set the value of amount
            amount: amountValue,
        };

        setHostRefererAmount(updatedRefererHosts);
    };

    const handleChangeRefererHostStatus = (e) => {
        const isChecked = e.target.checked;
        setRefererHostStatus(isChecked);
    }

    const handleChangeCountryCode = (country_slug) => {
        setCountryCodeSlug(country_slug);
    }

    const handleVrboEnableWaiver = (isOnStatus, partnerCoverageSlug, isHost = false) => {   // Function to handle the vrbo waiver selection
        const isChecked = isOnStatus;
        if (isChecked && waiverOptionType !== 4) { // If Airbnb or Vrbo flow is not selected then don't allow to turn on Vrbo
            Notification.addNotificationError(alertWaiverOptionMessage);
            return;
        }
        const newPartnerCoverageSlug = isChecked ? partnerCoverageSlug : '';  // setting slug value from switch
        const previousWaiver = isHost ? selectedIsVrboEnableHost : selectedIsVrboEnable; // getting previous waiver slug value from state
        if (!isChecked && isVrboListingConfig) {  // if vrbo is already configured to a listing then we can't turn off
            Notification.addNotificationError('Vrbo currently configured to a listing and can’t be turned off.');
            return;
        }

        let updatedArray = partnerCoverage.map((item) => {  // Update the partner coverage array based on the new selection
            if (item.partner_coverage_slug === newPartnerCoverageSlug) {  // comparing slug value from API and recieving data for host
                return {
                    ...item,
                    is_vrbo_enable: isChecked ? 1 : 0,
                    slug: item.slug || '',
                };
            } else if (item.partner_coverage_slug === previousWaiver) {   // if previous waiver slug matches with current slug
                if (item.is_default === 0 && item.is_coverage_enable === 0 && item.is_airbnb_enable === 0 && item.is_low_cost_enable === 0) {
                    return null;
                }
                return {
                    ...item,
                    is_vrbo_enable: 0,
                    slug: item.slug || '',
                };
            }
            setIsDirty(true)
            return item;
        }).filter(item => item !== null);

        // Add new item if not exist
        if (!updatedArray.find((item) => item.partner_coverage_slug === newPartnerCoverageSlug) && isChecked) {   // if new slug not found in partner coverage array
            const newItem = originalPartnerCoverage.find((item) => item.partner_coverage_slug === newPartnerCoverageSlug) || {};
            updatedArray.push({
                ...newItem,
                is_vrbo_enable: isChecked ? 1 : 0,
                is_airbnb_enable: (isHost ? selectedIsAirbnbEnableHost : selectedIsAirbnbEnable) === partnerCoverageSlug ? 1 : 0,
                is_low_cost_enable: (isHost ? selectedLowCostEnableHost : selectedLowCostEnable) === partnerCoverageSlug ? 1 : 0,
                is_default: (isHost ? selectedRadioHost : selectedRadio) === partnerCoverageSlug ? 1 : 0,
                partner_coverage_slug: newPartnerCoverageSlug,
                slug: newItem.slug || '',
                is_coverage_enable: 0,
            });
        }

        const cleanedArray = updatedArray.map((item) => ({    // cleaning the array to remove null values and set default values     
            ...item,
            is_coverage_enable: item?.is_coverage_enable || 0,
            is_airbnb_enable: item?.is_airbnb_enable || 0,
            is_low_cost_enable: item?.is_low_cost_enable || 0,
            is_vrbo_enable: item?.is_vrbo_enable || 0,
            is_default: item.is_default,
            partner_coverage_slug: item?.partner_coverage_slug,
            slug: item?.slug || '',
        }));
        setPartnerCoverageString(JSON.stringify(cleanedArray));
        isHost ? setIsVrboEnableHost(newPartnerCoverageSlug) : setIsVrboEnable(newPartnerCoverageSlug);
        setPartnerCoverage(updatedArray);
    };

    const handleChangeWaiverOptions = (waiver_option) => {
        if (waiver_option !== WAIVEROPTION.PURCHASE_WAIVERS_FOR_ALL_GUESTS && waiver_option !== WAIVEROPTION.PURCHASE_WAIVERS_FOR_ALL_GUESTS_WITH_HOLD_ONLY) {
            const shouldTriggerValidation = partnerCoverage.some(partner => {
                const provider = allProviderCoverage.find(
                    p => p.slug === partner.partner_coverage_slug
                );
                return provider && provider.is_checkout_invoicing_enabled === 1;
            });

            if (shouldTriggerValidation) {
                Notification.addNotificationError(alertWaiverOptionMessageAllGuest);
                return;
            }
        }
        setWaiverOptionType(waiver_option);
        setIsDirty(true);
    }

    const createFilters = (
        dataSource,
        key,
        options = { keepSymbol: false, isRaw: false, formatDollar: true }
    ) => {
        const seen = new Set(); // Track already-seen values to avoid duplicates

        return dataSource
            .map(item => {
                const raw = item?.[key]; // Get raw value from the item
                if (!raw) return null;

                // If using raw string filters (e.g., "$10" vs "10%"), skip numeric parsing
                if (options.isRaw) {
                    const trimmed = raw.trim();
                    if (seen.has(trimmed)) return null;
                    seen.add(trimmed);
                    return { text: trimmed, value: trimmed };
                }

                // Clean and parse the numeric value
                const cleaned = Number(
                    options.keepSymbol
                        ? raw.replace(/,/g, '') // Keep symbols like $ or % if required
                        : raw.replace(/[^0-9.-]+/g, '') // Remove all non-numeric characters
                );

                // Skip invalid or duplicate numbers
                if (isNaN(cleaned) || seen.has(cleaned)) return null;
                seen.add(cleaned);

                // Format the number as dollar or plain number string
                const formatted = options.formatDollar
                    ? `$${Number(cleaned).toLocaleString('en-US')}`
                    : Number(cleaned).toLocaleString('en-US');

                return { text: formatted, value: cleaned.toString() };
            })
            .filter(Boolean)
            .sort((a, b) => {
                let aVal = a.value;
                let bVal = b.value;
                if (key === 'additional_night_fee' || key === 'fee') {
                    aVal = a.value.replace(/[^0-9.-]+/g, ''); // clean a string by removing everything except numbers, dots, and minus signs.
                    bVal = b.value.replace(/[^0-9.-]+/g, '');
                }

                const aNum = parseFloat(aVal);
                const bNum = parseFloat(bVal);

                const bothNumbers = !isNaN(aNum) && !isNaN(bNum);

                if (bothNumbers) {
                    return aNum - bNum; // Numeric ascending
                } else {
                    return aVal.localeCompare(bVal); // Alphabetical A-Z
                }
            });// Remove nulls
    };
    const filteredDataSource = useMemo(() => {
        // If waiverOptionType is 1 then show all data
        if ((waiverOptionType === WAIVEROPTION.PURCHASE_WAIVERS_FOR_ALL_GUESTS) || (waiverOptionType === WAIVEROPTION.PURCHASE_WAIVERS_FOR_ALL_GUESTS_WITH_HOLD_ONLY)) {
            return dataSource;
        }
        // Otherwise then show only enable === 2
        return dataSource.filter(
            item => item.is_checkout_invoicing_enabled === 2
        );
    }, [waiverOptionType, dataSource]);

    const providerFilters = useMemo(
        () => createFilters(filteredDataSource, 'name', { isRaw: true }),
        [filteredDataSource]
    );
    const planNameFilters = useMemo(
        () => createFilters(filteredDataSource, 'plan_name', { isRaw: true }),
        [filteredDataSource]
    );

    // Filter options for the "Coverage Limit" column (formatted as currency)
    const coverageLimitFilters = useMemo(
        () => createFilters(filteredDataSource, 'coverage_limit'),
        [filteredDataSource]
    );

    // Filter options for the "Additional Night Fee" — uses raw strings to distinguish "$10" from "10%"
    const additionalNightFeeFilters = useMemo(
        () => createFilters(filteredDataSource, 'additional_night_fee', { isRaw: true }),
        [filteredDataSource]
    );

    // Filter options for the "On Nights Over" column (plain number, keeps comma)
    const onNightsOverFilters = useMemo(
        () => createFilters(filteredDataSource, 'on_night_over', { keepSymbol: true, formatDollar: false }),
        [filteredDataSource]
    );

    // Filter options for the "Min. Retail Price" column (formatted as currency)
    const minRetailPriceFilters = useMemo(
        () => createFilters(filteredDataSource, 'mrp'),
        [filteredDataSource]
    );

    // Filter options for the "Min Additional Night Rate" column (formatted as currency)
    const minAdditionalNightRateFilters = useMemo(
        () => createFilters(filteredDataSource, 'min_additional_night_rate'),
        [filteredDataSource]
    );

    // Filter options for the "Min Security Hold" column (formatted as currency)
    const minSecurityHoldFilters = useMemo(
        () => createFilters(filteredDataSource, 'min_security_hold'),
        [filteredDataSource]
    );

    // Filter options for the "Fee" column — uses raw strings to distinguish "$10" from "10%"
    const feeFilters = useMemo(
        () => createFilters(filteredDataSource, 'fee', { isRaw: true }),
        [filteredDataSource]
    );

    const handleSelectTheme = (themeSlug) => {
        if (themeSlug === undefined || themeSlug === null) {
            const defaultTheme = hostSlug === hostThemeCoastal
                ? listingThemeDropdownList.find((t) => t.applicable_css === "theme11")
                : listingThemeDropdownList.find((t) => !["theme6", "theme7", "theme11"].includes(t.applicable_css));
            if (defaultTheme) {
                setSelectedThemeSlug(defaultTheme.slug);
                form.setFieldsValue({ theme_slug: defaultTheme.slug });
            }
            return;
        }
        setSelectedThemeSlug(themeSlug);
        form.setFieldsValue({ theme_slug: themeSlug });
    };

    const fetchCmsContentforPreview = async () => {
        setSpinnerLoader(true);
        fetchCMSCommonFunction(27).then((res) => {
            const hasIntercomArticleId = Functions.findIntercomArticleId(res?.listing_preview_theme_info);
            if (!hasIntercomArticleId) {
                setOpenthemeCms(true)
                setPreviewCmsContent(res);
            }
            setSpinnerLoader(false);
        });
    }

    const handleSelectedGroupAccount = (groupAccountSlug) => { // Handle selection of a group account from dropdown
        setSelectedGroupAccountSlug(groupAccountSlug); // Update state with the selected group account slug
        form.setFieldsValue({ group_account_slug: groupAccountSlug }); // Update the form field value to reflect the selected group account
    };

    return (
        <>
            <Cards headless className="borderRadius common_fiter_table remove-min-h manage-hostconfig-spacing" bodypadding={'0px'}>
                <Spinner loader={spinnerLoader} />
                <Form form={form} name="host" onFinish={handleSubmit} onValuesChange={handleInputChange}>
                    <Cards headless className="p-0 manage-shared-edit-content-spacing" bodypadding={'0px'}>
                        <AddUser>
                            <BasicFormWrapper>
                                <Row gutter={15}>
                                    <Col xs={24} md={12} className="d-flex align-items-center ">
                                            <div className="project-modal">
                                                <div className="ninjadash-ticket-date-info__text">
                                                    <h4 className="ninjadash-ticket-details__top-title">Name </h4>
                                                    <span>{hostDetail?.name || ''}</span>
                                                </div>
                                            </div>
                                        </Col>
                                    <Col xs={24} md={12} className="d-flex align-items-center "></Col>
                                    <Col xs={24} md={12}>
                                        <div className="project-modal">
                                            <Form.Item
                                                className="early_check_input partner_common_label"
                                                label={'Custom Upsell Service Fee'}
                                                htmlFor='serviceFee'
                                            >
                                                <Input
                                                    suffix={'%'}
                                                    name={``}
                                                    placeholder="Enter custom upsell service fee"
                                                    value={serviceFee}
                                                    className="wifi readonlyInput"
                                                    onChange={(e) => handleServiceFeeChange(e)}
                                                    id='serviceFee'
                                                    tabIndex="7"
                                                />
                                            </Form.Item>
                                        </div>
                                    </Col>

                                    <Col xs={24} md={12}>
                                        <div className="project-modal">
                                            <Form.Item
                                                label={
                                                    <div className="theme-label">
                                                        <span>Theme </span>
                                                        <a className="common_urlLink" onClick={() => {fetchCmsContentforPreview()}}>(Learn: How it works)</a>
                                                    </div>
                                                }
                                                name="theme_slug"
                                                className="custom_input_style"
                                            >
                                                <Select
                                                    size="large"
                                                    className="ninjadash-fullwidth-select"
                                                    placeholder="Select Theme"
                                                    onChange={handleSelectTheme}
                                                    value={selectedThemeSlug || null}
                                                    allowClear
                                                >
                                                    {listingThemeDropdownList.map((value, index) => {
                                                        const isTheme6n7Host = hostSlug === hostTheme6n7;
                                                        const isCoastalHost = hostSlug === hostThemeCoastal;
                                                        const isTheme6or7 = ["theme6", "theme7"].includes(value.applicable_css);
                                                        const isCoastalTheme = value.applicable_css === "theme11";

                                                        if (!isTheme6n7Host && isTheme6or7) return null;
                                                        if (!isCoastalHost && isCoastalTheme) return null;

                                                        return (
                                                            <option key={index} value={value.slug}>
                                                                {value.theme_title}
                                                            </option>
                                                        );
                                                    })}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </Col>

                                    {domainName &&
                                        <Col xs={24} md={12}>
                                            <div className="project-modal">
                                                <Form.Item
                                                    label="Domain Name"
                                                    name="domain_name"
                                                    value={domainName}
                                                >
                                                    <Input readOnly tabIndex="8" className="wifi" />
                                                </Form.Item>
                                            </div>
                                        </Col>
                                    }
                                    <Col xs={24} md={12}>
                                        <div className="project-modal">
                                            <Form.Item
                                                label="Group Account"
                                                className="custom_input_style"
                                            >
                                                <Select
                                                    mode="multiple"
                                                    size="large"
                                                    className="ninjadash-fullwidth-select group-account-select-fix"
                                                    placeholder="Select Host"
                                                    onChange={handleSelectedGroupAccount} // Update state and form field when selection changes
                                                    value={selectedGroupAccountSlug || []} // Controlled value from state (fallback to empty array)
                                                    allowClear
                                                    maxTagCount="responsive"
                                                    showSearch
                                                    filterOption={(input, option) => {
                                                        const children = option.props.children;
                                                        if (typeof children === 'string') {
                                                            return children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                        } else if (Array.isArray(children)) {
                                                            const concatenatedString = children.join('');
                                                            return concatenatedString.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                        }
                                                        return false;
                                                    }}
                                                >
                                                    {memberUserDropdownList.map((value, index) => (
                                                        <option key={index} value={value.slug}>
                                                            {value.name}
                                                            {/* Display member user's name and use slug as value */}
                                                        </option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </Col>
                                    <Col xs={24} md={12} className="">
                                        <div className="project-modal">
                                            <Form.Item
                                                label={
                                                    <span>
                                                        <span className="requiredFiled">*</span> Country Name
                                                    </span>
                                                }
                                                className="custom_input_style"
                                            >
                                                <Select
                                                    size="large"
                                                    className="ninjadash-fullwidth-select"
                                                    placeholder="Select country name"
                                                    showSearch
                                                    allowClear
                                                    disabled
                                                    filterOption={(input, option) => {
                                                        const children = option.props.children;
                                                        if (typeof children === 'string') {
                                                            return children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                        } else if (Array.isArray(children)) {
                                                            const concatenatedString = children.join('');
                                                            return concatenatedString.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                        }
                                                        return false;
                                                    }}
                                                    onChange={(e) => handleChangeCountryCode(e)}
                                                    // defaultValue={"US"}
                                                    value={countryCodeSlug}
                                                >
                                                    {countryCodeDropdown.map((value, index) => (
                                                        <option key={index} value={value.slug}>
                                                            {value.country_name}
                                                        </option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                        {isRequiredCountryCode && !countryCodeSlug && (
                                            <div className="showImageError">
                                                <div className="ant-form-item-has-error ant-form-item-explain-error">
                                                    Please select country name
                                                </div>
                                            </div>
                                        )}
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <div className="project-modal">
                                            <Form.Item
                                                className='checkbox-title-inline'
                                                label={
                                                    <span>
                                                        Referral Host
                                                    </span>
                                                }
                                                labelCol={{ className: 'custom-checkbox-label' }}
                                            >
                                                <Checkbox className='cus-checkbox-inline' onChange={handleChangeRefererHostStatus} checked={refererHostStatus} id={'referer_host'}></Checkbox>
                                            </Form.Item>
                                        </div>
                                    </Col>

                                    {refererHostStatus && refererHosts.map((host, index) => (
                                        <React.Fragment key={index}>
                                            <Col xs={24} md={12}>
                                                <div className={`project-modal`}>
                                                    <Form.Item
                                                        label={<span>{host.label}</span>}
                                                        className="custom_input_style"
                                                        name={host.name}
                                                        rules={[
                                                            {
                                                                required: hostRefererAmount[index]?.amount > 0 || selectedHostReferer[index]?.host_slug !== '',
                                                                message: `Please select ${host.label.toLowerCase()}`,
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            size="large"
                                                            className="ninjadash-fullwidth-select"
                                                            placeholder={`Select ${host.label.toLowerCase()}`}
                                                            showSearch
                                                            allowClear
                                                            filterOption={(input, option) => {
                                                                const children = option.props.children;
                                                                if (typeof children === 'string') {
                                                                    return children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                                } else if (Array.isArray(children)) {
                                                                    const concatenatedString = children.join('');
                                                                    return concatenatedString.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                                }
                                                                return false;
                                                            }}
                                                            onChange={(e) => handleSelectRefererHost(e, index)}
                                                        >
                                                            {hostRefererDropDown?.map((host, index) => {
                                                                if (selectedHostRefererSlug.includes(host.slug)) {
                                                                    return null;
                                                                }
                                                                return (
                                                                    <option key={index} value={host.slug}>
                                                                        {host.name}
                                                                    </option>
                                                                );
                                                            })}
                                                        </Select>
                                                    </Form.Item>
                                                </div>
                                            </Col>
                                            <Col xs={24} md={12}>
                                                <div className="project-modal">
                                                    <Form.Item
                                                        label="Referral Amount"
                                                        name={host.amountName}
                                                        rules={[
                                                            {
                                                                required: hostRefererAmount[index]?.amount > 0 || selectedHostReferer[index]?.host_slug !== '',
                                                                message: 'Please enter referral amount',
                                                            },
                                                            {
                                                                validator: (_, value) => {
                                                                    if (value && value < 1 && value != '') {
                                                                        return Promise.reject(new Error('Referral amount cannot be less than 0'));
                                                                    }
                                                                    return Promise.resolve();
                                                                },
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            autoComplete='Off'
                                                            placeholder="Enter amount"
                                                            onChange={(e) => handleChangeAmount(e, index)}
                                                            value={hostRefererAmount[index]?.amount}
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Col>
                                        </React.Fragment>
                                    ))}
                                </Row>
                                <Row gutter={15}>
                                    <Col xs={24} md={12}>
                                        <div className="project-modal">
                                            <Form.Item label="Status" name="status_id">
                                                <Switch size="large" checked={status} onChange={changeStatus} className="switch-toggle" />
                                            </Form.Item>
                                        </div>
                                    </Col>
                                    {hostSlug && (
                                        <Col xs={24} md={12} className="d-flex align-items-center ">
                                            <div className="project-modal">
                                                <div className="ninjadash-ticket-date-info__text">
                                                    <h4 className="ninjadash-ticket-details__top-title">Stripe Account Status </h4>
                                                    <span>{hostDetail?.is_stripe_status == 2 ? 'Linked' : 'Not Linked'}</span>
                                                </div>
                                            </div>
                                        </Col>
                                    )}
                                </Row>
                                <Row>
                                    <Col xs={24} md={12}>
                                        <div className="project-modal">
                                            <Form.Item
                                                className='checkbox-title-inline'
                                                label="Chat Enabled"
                                                labelCol={{ className: 'custom-checkbox-label' }}
                                            >
                                                <Checkbox className='cus-checkbox-inline' onChange={handleChatEnabledChange} checked={isChatEnabled}></Checkbox>
                                            </Form.Item>
                                        </div>
                                    </Col>
                                </Row>
                                <Divider />
                                <Heading as="h6" className="required-label">
                                    <span className="error require"></span> Waiver Options {' '}
                                </Heading>
                                <Row gutter={15}>
                                    <Col xs={24} md={12}>
                                        <div className="project-modal">
                                            <Form.Item
                                                label={
                                                    <span>
                                                        <span className="requiredFiled">*</span> Select Options
                                                    </span>
                                                }
                                                className="custom_input_style"
                                            >
                                                <Select
                                                    size="large"
                                                    className="ninjadash-fullwidth-select"
                                                    placeholder="Select options"
                                                    showSearch
                                                    allowClear
                                                    filterOption={(input, option) => {
                                                        const children = option.props.children;
                                                        if (typeof children === 'string') {
                                                            return children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                        } else if (Array.isArray(children)) {
                                                            const concatenatedString = children.join('');
                                                            return concatenatedString.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                        }
                                                        return false;
                                                    }}
                                                    onChange={(e) => handleChangeWaiverOptions(e)}
                                                    value={waiverOptionType}
                                                >
                                                    {hostWaiverDropDown.map((value, index) => (
                                                        <option key={index} value={value.type}>
                                                            {value.option}
                                                        </option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                        {isRequiredWaiverOption && !waiverOptionType && (
                                            <div className="showImageError">
                                                <div className="ant-form-item-has-error ant-form-item-explain-error">
                                                    Please select waiver option
                                                </div>
                                            </div>
                                        )}
                                        {waiverOptionType && waiverOptionType != 3 && (
                                            <span className='waiver-select-option-span'>
                                                <InfoCircleOutlined className='image-waiver-select-option' /><span className='editor-para' dangerouslySetInnerHTML={{ __html: cmsTextHostCharge }} />
                                            </span>
                                        )}
                                    </Col>
                                    {
                                        waiverOptionType != 3 && hostSlug && (
                                            <Col xs={24} md={12}>
                                                <div className="project-modal">
                                                    <Form.Item
                                                        label="Stripe Customer ID"
                                                        name="stripe_customer_id"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Please enter stripe customer id',
                                                            },
                                                            {
                                                                validator: (_, value) => {
                                                                    if (value) {
                                                                        if (!/^cus_[a-zA-Z0-9]{10,}$/.test(value)) {
                                                                            return Promise.reject('Stripe Customer ID must start with "cus_" and be valid');
                                                                        }
                                                                    }
                                                                    return Promise.resolve();
                                                                },
                                                            },
                                                        ]}
                                                    >
                                                        <Input placeholder="Enter stripe customer id" tabIndex="8" />
                                                    </Form.Item>
                                                </div>
                                            </Col>
                                        )
                                    }
                                </Row>
                            </BasicFormWrapper>
                        </AddUser>
                    </Cards>
                    <Cards headless className="coverage_table_card common_fiter_table">
                        <Table dataSource={filteredDataSource} pagination={false} rowKey="slug" className="table-responsive coverage-table">
                            <Column
                                title="Low Cost"
                                key="is_low_cost_enable"
                                filters={[
                                    { text: 'ON', value: true },
                                    { text: 'OFF', value: false },
                                ]}
                                onFilter={(value, record) => {
                                    const isOn = hostSlug
                                        ? selectedLowCostEnableHost === record.slug
                                        : selectedLowCostEnable === record.slug;
                                    return value ? isOn : !isOn;
                                }}
                                filterIcon={filtered => (
                                    filtered ? <FilterFilled /> : <DownOutlined />
                                )}
                                render={(text, record) => (
                                    <Switch
                                        checked={hostSlug ? selectedLowCostEnableHost === record.slug : selectedLowCostEnable === record.slug}
                                        onChange={(e) => handleLowCostEnableWaiver(e, record.slug, !!hostSlug)}
                                        value={record.slug}
                                        name='is_low_cost_enable'
                                        size="large"
                                        className="switch-toggle"
                                    />
                                )}
                            />
                            <Column
                                title="Airbnb Only"
                                key="is_airbnb_enable"
                                filters={[
                                    { text: 'ON', value: true },
                                    { text: 'OFF', value: false },
                                ]}
                                onFilter={(value, record) => {
                                    const isOn = hostSlug
                                        ? selectedIsAirbnbEnableHost === record.slug
                                        : selectedIsAirbnbEnable === record.slug;
                                    return value ? isOn : !isOn;
                                }}
                                filterIcon={filtered => (
                                    filtered ? <FilterFilled /> : <DownOutlined />
                                )}
                                render={(text, record) => (
                                    <Switch
                                        checked={hostSlug ? selectedIsAirbnbEnableHost === record.slug : selectedIsAirbnbEnable === record.slug}
                                        onChange={(e) => handleAirbnbEnableWaiver(e, record.slug, !!hostSlug)}
                                        value={record.slug}
                                        name='is_airbnb_enable'
                                        size="large"
                                        className="switch-toggle"
                                    />
                                )}
                            />
                            <Column
                                title="Vrbo Only"
                                key="is_vrbo_enable"
                                filters={[
                                    { text: 'ON', value: true },
                                    { text: 'OFF', value: false },
                                ]}
                                onFilter={(value, record) => {
                                    const isOn = hostSlug
                                        ? selectedIsVrboEnableHost === record.slug
                                        : selectedIsVrboEnable === record.slug;
                                    return value ? isOn : !isOn;
                                }}
                                filterIcon={filtered => (
                                    filtered ? <FilterFilled /> : <DownOutlined />
                                )}
                                render={(text, record) => (
                                    <Switch
                                        checked={hostSlug ? selectedIsVrboEnableHost === record.slug : selectedIsVrboEnable === record.slug}
                                        onChange={(e) => handleVrboEnableWaiver(e, record.slug, !!hostSlug)}
                                        value={record.slug}
                                        name='is_vrbo_enable'
                                        size="large"
                                        className="switch-toggle"
                                    />
                                )}
                            />
                            <Column
                                title="Default"
                                key="select_radio"
                                filters={[
                                    { text: 'ON', value: true },
                                    { text: 'OFF', value: false },
                                ]}
                                onFilter={(value, record) => {
                                    const isOn = hostSlug
                                        ? selectedRadioHost === record.slug
                                        : selectedRadio === record.slug;
                                    return value ? isOn : !isOn;
                                }}
                                filterIcon={filtered => (
                                    filtered ? <FilterFilled /> : <DownOutlined />
                                )}
                                render={(text, record) => (
                                    <Radio
                                        checked={hostSlug ? selectedRadioHost === record.slug : selectedRadio === record.slug}
                                        onChange={(e) => handleRadioChangeGeneral(e, !!hostSlug)}
                                        value={record.slug}
                                        name='default_coverage'
                                    />
                                )}
                            />
                            <Column
                                title="Display"
                                key="select_switch"
                                filters={[
                                    { text: 'ON', value: true },
                                    { text: 'OFF', value: false },
                                ]}
                                onFilter={(value, record) => {
                                    const isOn = hostSlug
                                        ? !!selectedSwitchesHost[record.slug]
                                        : !!selectedSwitches[record.slug];
                                    return value ? isOn : !isOn;
                                }}
                                filterIcon={filtered => (
                                    filtered ? <FilterFilled /> : <DownOutlined />
                                )}
                                render={(text, record) => (
                                    <Switch
                                        checked={hostSlug ? !!selectedSwitchesHost[record.slug] : !!selectedSwitches[record.slug]}
                                        onChange={(checked) => handleSwitchChangeGeneral(checked, record.slug, !!hostSlug)}
                                        disabled={hostSlug ? record.slug === selectedRadioHost : record.slug === selectedRadio}
                                        size="large"
                                        className="switch-toggle"
                                        name='display_coverage'
                                    />
                                )}
                            />
                            <Column
                                title="Provider"
                                dataIndex="name"
                                key="name"
                                sorter={(a, b) => a.name.localeCompare(b.name)}
                                filterSearch={true}
                                filters={providerFilters}
                                filterIcon={filtered => (
                                    filtered ? <FilterFilled /> : <DownOutlined />
                                )}
                                onFilter={(value, record) => record.name === value}
                            />
                            <Column
                                title="Plan Name"
                                dataIndex="plan_name"
                                key="plan_name"
                                sorter={(a, b) => (a.plan_name || '').localeCompare(b.plan_name || '')}
                                filterSearch={true}
                                filters={planNameFilters}
                                filterIcon={filtered => (
                                    filtered ? <FilterFilled /> : <DownOutlined />
                                )}
                                onFilter={(value, record) => record.plan_name === value}
                            />
                            <Column title="Coverage Limit" dataIndex="coverage_limit" key="coverage_limit" sorter={(a, b) => {
                                const numA = Number(a.coverage_limit.replace(/[^0-9.-]+/g, ''));
                                const numB = Number(b.coverage_limit.replace(/[^0-9.-]+/g, ''));
                                return numA - numB;
                            }}
                                filters={coverageLimitFilters}
                                onFilter={(value, record) => {
                                    // Extract numeric value from coverage_limit and compare with filter value
                                    const num = Number(record.coverage_limit.replace(/[^0-9.-]+/g, ''));
                                    return num.toString() === value;
                                }}
                                filterIcon={filtered => (
                                    filtered ? <FilterFilled /> : <DownOutlined />
                                )}
                            />
                            <Column title="Fee"
                                dataIndex="fee"
                                key="fee"
                                filters={feeFilters}
                                onFilter={(value, record) => {
                                    return record.fee?.trim() === value;
                                }}
                                filterIcon={filtered => (
                                    filtered ? <FilterFilled /> : <DownOutlined />
                                )}
                            />
                            <Column title="Additional Nightly Fee"
                                dataIndex="additional_night_fee"
                                key="additional_night_fee"
                                filters={additionalNightFeeFilters}
                                onFilter={(value, record) => {
                                    return record.additional_night_fee?.trim() === value;
                                }}
                                filterIcon={filtered => (
                                    filtered ? <FilterFilled /> : <DownOutlined />
                                )}
                            />
                            <Column title={[WAIVEROPTION.PURCHASE_WAIVERS_FOR_ALL_GUESTS, WAIVEROPTION.PURCHASE_WAIVERS_FOR_ALL_GUESTS_WITH_HOLD_ONLY].includes(waiverOptionType) ? 'On Nights Over / Nights Per Set' : 'On Nights Over'} dataIndex="on_night_over" key="on_night_over" sorter={(a, b) => {
                                const numA = Number(a.on_night_over.replace(/,/g, ''));
                                const numB = Number(b.on_night_over.replace(/,/g, ''));
                                return numA - numB;
                            }}
                                filters={onNightsOverFilters}
                                onFilter={(value, record) => {
                                    const num = Number(record.on_night_over.replace(/,/g, ''));
                                    return num.toString() === value;
                                }}
                                filterIcon={filtered => (
                                    filtered ? <FilterFilled /> : <DownOutlined />
                                )}
                            />
                            <Column title="Min. Retail Price" dataIndex="mrp" key="mrp" sorter={(a, b) => {
                                const numA = Number(a.mrp.replace(/[^0-9.-]+/g, ''));
                                const numB = Number(b.mrp.replace(/[^0-9.-]+/g, ''));
                                return numA - numB;
                            }}
                                filters={minRetailPriceFilters}
                                onFilter={(value, record) => {
                                    const num = Number(record.mrp.replace(/[^0-9.-]+/g, ''));
                                    return num.toString() === value;
                                }}
                                filterIcon={filtered => (
                                    filtered ? <FilterFilled /> : <DownOutlined />
                                )}
                            />
                            <Column
                                title="Min. Additional Nightly Rate"
                                dataIndex="min_additional_night_rate"
                                key="min_additional_night_rate"
                                sorter={(a, b) => {
                                    const numA = Number(a.min_additional_night_rate.replace(/[^0-9.-]+/g, ''));
                                    const numB = Number(b.min_additional_night_rate.replace(/[^0-9.-]+/g, ''));
                                    return numA - numB;
                                }}
                                filters={minAdditionalNightRateFilters}
                                onFilter={(value, record) => {
                                    const num = Number(record.min_additional_night_rate.replace(/[^0-9.-]+/g, ''));
                                    return num.toString() === value;
                                }}
                                filterIcon={filtered => (
                                    filtered ? <FilterFilled /> : <DownOutlined />
                                )}
                            />
                            <Column
                                title="Min. Security Hold"
                                dataIndex="min_security_hold"
                                key="min_security_hold"
                                sorter={(a, b) => {
                                    const numA = Number(a.min_security_hold.replace(/[^0-9.-]+/g, ''));
                                    const numB = Number(b.min_security_hold.replace(/[^0-9.-]+/g, ''));
                                    return numA - numB;
                                }}
                                filters={minSecurityHoldFilters}
                                onFilter={(value, record) => {
                                    const num = Number(record.min_security_hold.replace(/[^0-9.-]+/g, ''));
                                    return num.toString() === value;
                                }}
                                filterIcon={filtered => (
                                    filtered ? <FilterFilled /> : <DownOutlined />
                                )}
                            />
                        </Table>
                    </Cards>
                </Form>
            </Cards>

            <div className="manage-listing-btn">
                {/* <Col xs={4}> */}
                <Button
                    htmlType="submit"
                    size="default"
                    shape="circle"
                    type="primary"
                    key="submit"
                    className="update-btn"
                    // onClick={() => form.submit()}
                    onClick={checkValidation}
                >
                    {spinnerLoader ? 'Loading...' : buttonName}
                </Button>
                <Button
                    onClick={handleCancel}
                    shape="circle" className="form-cancel-btn" outlined type="primary">
                    Cancel
                </Button>
                {/* </Col> */}
            </div>
            <Modal
                type='primary'
                open={openthemeCms}
                onCancel={() => setOpenthemeCms(false)}
                footer={null}
                className="modal-md"
                key={2}
                destroyOnClose
                aria-hidden="false"
            >
                <div className="Idmodalbox earlyCheckinPopup">
                    <div className="hostPayout">
                        <div className="modal-content" dangerouslySetInnerHTML={{ __html: previewCmsContent?.listing_preview_theme_info }} />
                    </div>
                </div>
            </Modal>
        </>
    );
}
export default EditHostConfiguration;